namespace e5.ScrollViewResize {
    export class ScrollViewResizeCenter implements IScrollViewResize {
        public getTransform(view: ScrollView, widthBefore: number, heightBefore: number): ScrollViewTransform {
            var local = view.containerToContent(widthBefore * 0.5, heightBefore * 0.5);
            return {
                scale: view.scale,
                x: view.width * 0.5 - local.x * view.scale,
                y: view.height * 0.5 - local.y * view.scale
            };
        }
    }

    export const Center = new ScrollViewResizeCenter();
}